import About from "@/views/About";
import Blog from "@/views/Blog";
import BlogDetail from "@/views/Blog/Detail";
import Home from "@/views/Home";
import Message from "@/views/Message";
import Project from "@/views/Project";

const routes = [
  {
    name: "Home",
    path: "/",
    component: Home,
    meta:{
      title: '首页'
    }
  },
  {
    name: "About",
    path: "/About",
    component: About,
    meta:{
      title: '关于我'
    }
  },
  {
    name: "Blog",
    path: "/Blog",
    component: Blog,
    meta:{
      title: '文章'
    }
  },
  {
    name: "BlogCategory",
    path: "/Blog/category/:id",
    component: Blog,
    meta:{
      title: '文章'
    }
  },
  {
    name: "BlogDetail",
    path: "/Blog/:id",
    component: BlogDetail,
    meta:{
      title: '文章详情'
    }
  },
  {
    name: "Message",
    path: "/Message",
    component: Message,
    meta:{
      title: '留言板'
    }
  },
  {
    name: "Project",
    path: "/Project",
    component: Project,
    meta:{
      title: '项目&效果'
    }
  },
];

export default routes;
